import { UserClaimDto, UserRole } from "../models/app/userMe";

export const hasClaim = (userRoleId: UserRole, userClaims?: UserClaimDto[], ): boolean => {
    return userClaims ? userClaims.some(claim => claim.claimTypeId === userRoleId) : false;
};